import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { UpsellButtonInterface } from 'common/types/entities/button-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import createCommonEntitySettings from '../createCommonEntitySettings'
import UpsellButtonSettings from './settings/UpsellButtonSettings'

function createSettingsForUpsell(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.UpsellAgreeButton:
    case EntityTypeEnum.UpsellDisagreeButton:
      return (
        <UpsellButtonSettings
          entity={entity as UpsellButtonInterface}
          defaultEntity={defaultEntity as UpsellButtonInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForUpsell
